// extracted by mini-css-extract-plugin
export var container = "style-module--container--6c039";
export var hidden = "style-module--hidden--98e15";
export var icon = "style-module--icon--bb95c";
export var shown = "style-module--shown--dec06";
export var spinner = "style-module--spinner--5ff79";
export var title = "style-module--title--a457e";
export var video = "style-module--video--4473d";
export var videoOnlyContainer = "style-module--videoOnlyContainer--93e24";